import { IPagination } from "../../../interfaces/IPagination";
import Pagination, { PaginationProps } from "../Pagination";
import CustomTable, { CustomTableProps } from "../Table/CustomTable";

export type DataTableProps<T> = CustomTableProps<T> & {
  pagination: IPagination & Pick<PaginationProps, "onPageChange">;
};

export const DataTable = <T extends {}>(props: DataTableProps<T>) => {
  const { pagination, ...tableProps } = props;
  return (
    <>
      <CustomTable {...tableProps} />
      <Pagination {...pagination} />
    </>
  );
};
